import { useQuery } from 'react-query';

import { getModMailingBranding } from 'modules/api/digitalServices/mailOnDemand';

import CoverLetterPreview from '../MailOnDemandWizard/components/CoverLetterPreview';
import strings from '../strings';

/**
 * Presentational wrapper (ADR-002) that turns `{ templateKey, body, width }`
 * into a faithful, branded cover-letter thumbnail.
 *
 * It reuses the existing `CoverLetterPreview` renderer and self-fetches the
 * member's branding from the cached `modMailingBranding` query — the SAME key
 * the editor uses — so callers (PayStep, ConfirmationStep) need no branding
 * wiring. The preview is decorative (`aria-hidden`) and degrades gracefully
 * while branding is loading (no crash, no "undefined").
 */
const CoverLetterMiniPreview = ({
  templateKey = 'classic',
  body,
  width = 64,
  leadName,
}) => {
  const { data: branding } = useQuery('modMailingBranding', getModMailingBranding, {
    staleTime: 5 * 60 * 1000,
  });

  return (
    <div aria-hidden="true">
      <CoverLetterPreview
        templateKey={templateKey}
        body={body}
        width={width}
        branding={branding || {}}
        leadName={leadName || strings.coverLetter.sampleLeadName}
      />
    </div>
  );
};

export default CoverLetterMiniPreview;
